import React, {
  createContext,
  useReducer,
  useState,
  useEffect,
  useContext,
  useRef
} from 'react'
import { Promise } from 'es6-shim'
import { Button } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import CompanyDetailsWidget from './CompanyDetailsWidget'
import DeliveryLocationWidget from './DeliveryLocationWidget'
import AvailableContractTypesWidget from './AvailableContractTypesWidget'
import UploadLegalFilesWidget from './UploadLegalFilesWidget'
import DeliveryWidget from './DeliveryWidget'
import { LanguageContext } from '../../../services/context'
import {
  getContractTypes,
  createNewProductionPlan,
  getCompany,
  uploadContractTemplate,
  getLanguageByCompany
} from '../../../services/apiHelper'
import { GlobalContext } from '../../../services/context'
import useQuery from '../../../services/useQuery'
import useApiHelper from '../../../services/useApiHelper'
import ParentProductionPlanWidget from './ParentProductionPlanWidget'
import ProductionPlanModal from './ProductionPlanModal'
export const ProductionPlanContext = createContext()

const ProductionPlanReducer = (state, action) => {
  switch (action.type) {
    case 'POSTS_COMPLETE':
      return {
        ...state,
        showModal: true,
        submissionStatus: action.payload.submissionStatus,
        dispatchObj: action.payload?.dispatchObj
      }
    case 'SET_MODAL': {
      let showModal = action.payload === 'SUCCESS' ? true : false
      return { ...state, showModal }
    }
    case 'START_POST': {
      return { ...state, showModal: true, submissionStatus: 'LOADING' }
    }
    case 'UPDATE_COMPANY_DETAILS':
      return {
        ...state,
        company_details: action.payload,
        updateCompanyDetails: true
      }
    case 'FINISHED_UPDATING_COMPANY':
      return { ...state, updateCompanyDetails: false }
    case 'UPDATE_DELIVERY_LOCATION':
      return { ...state, delivery_location: action.payload }
    case 'UPDATE_SELECTED_CONTRACT_TYPE':
      return { ...state, selected_contract_type: action.payload }
    case 'UPDATE_LEGAL_FILES': {
      const newState = { ...state }
      if (action.payload) {
        newState.legal_files = action.payload
      }
      if(action.payload) {
        newState.errors = { ...newState.errors, legal_files: [] }
      } else {
        newState.errors = {
          ...newState.errors,
          legal_files: [...newState.errors.legal_files, 'Missing legal file']
        }
      }
      return newState
    }
    case 'UPDATE_MONTHLY_UNITS': {
      const newState = { ...state }
      if (action.payload.length) {
        newState.monthly_units = action.payload
        for(let i = 0; i < action.payload.length; i++){
          if(action.payload[i].premium_type){
            newState.premium_type = action.payload[i].premium_type
            break
          }
        }
        newState.errors = { ...newState.errors, delivery: [] }
      } else {
        // newState.monthly_units = []
        newState.errors = {
          ...newState.errors,
          delivery: [
            ...newState.errors.delivery,
            'Must have at least one completed delivery row'
          ]
        }
      }
      return newState
    }
    case 'UPDATE_TOTAL_ACRES':
      return { ...state, total_acres: action.payload.toString() }
    case 'UPDATE_TOTAL_UNITS':
      return { ...state, total_units: action.payload.toString() }
    case 'UPDATE_TOTAL_CHILD_ACRES':
      return { ...state, total_child_acres: action.payload.toString() }
    case 'UPDATE_TOTAL_CHILD_UNITS':
      return { ...state, total_child_units: action.payload.toString() }
    case 'UPDATE_CONTRACT_YEAR':
      return { ...state, contract_year: parseInt(action.payload) }
    case 'UPDATE_APH':
      return { ...state, aph: action.payload }
    case 'UPDATE_PROD_PLAN_INVENTORY':
      return { ...state, inventory_code: action.payload }
    case 'UPDATE_PARENT_PRODUCTION_PLAN':
      return { ...state, parent_production_plan_id: action.payload.production_plan_id, parent_production_plan: action.payload.prod_plan_obj }
    case 'HAS_COMPANY_ID':
      return {
        ...state,
        company_name: action.payload.company_name,
        external_reference_id: action.payload.external_reference_id,
        company_id: action.payload.external_reference_id,
        company_inventory_code: action.payload.company_inventory_code
      }
    case 'HAS_CONTEXT':
      return {
        ...state,
        company_name: action.payload.company_name,
        external_reference_id: action.payload.external_reference_id,
        company_id: action.payload.external_reference_id,
        parent_production_plan_id: action.payload.parent_production_plan_id
      }
    case 'ERRORS': {
      const newState = { ...state, rightSideState: 'FAILED' }
      for (let widget in newState.errors) {

        if(!Object.prototype.hasOwnProperty.call(action.payload,widget)){
          newState.errors[widget] = []
        }
      }
      for (let widget in action.payload) {
        newState.errors[widget]=[]
        newState.errors[widget].push(action.payload[widget])
      }
      return newState
    }
    case 'NOERRORS': {
      const newState = { ...state, rightSideState: 'SUCCESS' }
      for (let widget in newState.errors) {
        if(!Object.prototype.hasOwnProperty.call(action.payload,widget)){
          newState.errors[widget] = []
        }
      }
      for (let widget in action.payload) {
        newState.errors[widget]=[]
        newState.errors[widget].push(action.payload[widget])
      }
      return newState
    }
    case 'UPDATE_CONTRACT_YEAR_ERROR': {
      const newState = { ...state }
      const isProductionPlanExist = action.payload.prodPlanData?.some(data => data.contract_year === action.payload.contractYear)
      if (isProductionPlanExist) {
        newState.errors = {
          ...newState.errors,
          contract_year: ['Production plan already exists for this year']
        }
      } else {
        newState.errors = { ...newState.errors, contract_year: [] }
      }
      return newState
    }
    default:
      throw new Error()
  }
}

const CreateProductionPlanView = () => {
  const { state, dispatch, trackEvent } = useContext(GlobalContext)
  const [contractTypes, setContractTypes] = useState([])
  const [
    initial_delivery_location_data,
    set_initial_delivery_location_data
  ] = useState()
  const [company_id, set_company_id] = useState(useQuery().get('company_id'))
  const langData =  useContext(LanguageContext)
  const [companyLang, setCompanyLang] =  useState([])
  const [
    { data: prodPlanData },
    getProductionPlan
  ] = useApiHelper('getProductionPlan')
  const [planState, planDispatch] = useReducer(ProductionPlanReducer, {
    rightSideState: 'EMPTY',
    showModal: false,
    submissionStatus: 'FAILED',
    errors: {
      aph: [],
      total_units: [],
      delivery: [],
      legal_files: [],
      selected_contract_type: [],
      inventory_code: [],
      total_acres: [],
      contract_year: []
    }
  })

  useEffect(() => {
    const init = async () => {
      getProductionPlan(company_id, 'company_id', true)
    }
    if (company_id) {
      init()
    }
  }, [company_id, getProductionPlan])

  useEffect(() => {
    getLanguageByCompany(company_id , langData).then(obj => {
      setCompanyLang(obj)
    })
  }, [company_id, langData])


  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])
  const checkForErrors = () => {
    let errors = {}
    if(!parseInt(planState.aph)){errors.aph='Missing Aph Value'}
    if(!parseInt(planState.total_acres)){errors.total_acres='Missing total acres Value'}
    if(!parseInt(planState.total_units)){errors.total_units='Missing Total Bushels'}
    if(planState.inventory_code === 'invalid_code'){errors.inventory_code='Please enter a Production Plan inventory code (It should be in capital letter, the length should be 6 and only contain alphabetical letters or numbers)'}
    if(!planState.inventory_code){errors.inventory_code='Please enter a Production Plan inventory code'}
    let legalFileSize = false
    let legalFiletype = false
    if(planState?.legal_files?.length > 0) {
      planState.legal_files.forEach(data => {
        if(!window.atob(data.template_base64).startsWith('%PDF-')) {
          legalFiletype = true
        }
        const binaryData = window.atob(data.template_base64)
        const fileSize = binaryData.length/1000000
        if(fileSize.toFixed(2) > 5) {
          legalFileSize = true
        }
      })
      if(legalFiletype === true) {
        errors.legal_files = 'Wrong file format, it should be PDF'
      }
      else if(legalFileSize === true) {
        errors.legal_files = 'PDF file size should be less than 5MB'
      }
    }

    if(legalFileSize === false) {
      if (!planState.legal_files) {
        errors.legal_files = 'Missing PDF or wrong file format'
      }
    }
    if (
      !planState.selected_contract_type ||
      !planState.selected_contract_type.contract_type_id
    ) {
      errors.selected_contract_type = 'Missing contract type'
    }
    let availableAcres = true
    if(planState.monthly_units){
      planState.monthly_units.forEach(data => {
        if(data.available_acres && data.available_acres !== '0'){
          availableAcres = false
        }
      })
    }
    if (!planState.monthly_units || !planState.monthly_units.length || availableAcres) {
      errors.delivery =
        'The delivery table must have at least one full delivery month'
    }

    const isProductionPlanExist = prodPlanData?.some(data => data.contract_year === planState.contract_year)
    if (isProductionPlanExist) {
      errors.contract_year =
        'Production plan already exists for this year'
    }

    if (JSON.stringify(errors) === '{}') {
      planDispatch({ type: 'NOERRORS', payload: errors })
      return true
    } else {
      planDispatch({ type: 'ERRORS', payload: errors })
      return false
    }
  }

  const updateLegalFile = template_detail => {
    let legalFiles = planState.legal_files
    if(legalFiles?.length > 0) {
      const findIndex = legalFiles.findIndex(x => x.template_language === template_detail.template_language)
      if(findIndex!== -1) {
        legalFiles[findIndex] = template_detail
      } else {
        legalFiles = [...legalFiles, template_detail]
      }
    } else {
      legalFiles = [template_detail]
    }
    planDispatch({
      type: 'UPDATE_LEGAL_FILES',
      payload: legalFiles,
      companyLang: companyLang
    })
  }

  const updateContractTemplate = async production_plan_id => {
    if(planState.legal_files.length > 0) {
      planState.legal_files.forEach(async legalFile => {
        return await uploadContractTemplate(
          planState.selected_contract_type.contract_type_id,
          planState.external_reference_id,
          legalFile.template_base64,
          legalFile.template_name,
          legalFile.template_language,
          production_plan_id
        )

      })
    }
    return Promise.resolve(true)
  }

  const submitPlan = async() => {
    trackEvent('save_new_production_plan_clicked', { companyId: company_id })
    if (!checkForErrors()) {
      return
    }

    const prodPlanPromise = await createNewProductionPlan(planState)
    const templatePromise = updateContractTemplate(prodPlanPromise?.production_plan_id)
    planDispatch({ type: 'START_POST' })
    try {
      Promise.allSettled([templatePromise, prodPlanPromise]).then(values => {
        const templateResult = values[0]
        const prodPlanResult = values[1]
        let submissionStatus = 'SUCCESS'
        let dispatchObj
        if (!templateResult?.value) {
          submissionStatus = 'FAILED_TEMPLATE'
        }
        if (prodPlanResult?.value) {
          dispatchObj = {
            type: 'GO_TO_COMPANY_DETAIL_VIEW',
            payload: {
              company_id,
              detailView: { previous: 'Back', title: prodPlanResult.value.company_name }
            }
          }
        } else {
          submissionStatus = 'FAILED'
        }
        planDispatch({
          type: 'POSTS_COMPLETE',
          payload: { submissionStatus, dispatchObj }
        })
      })
    } catch (err) {
      console.error('Promise failed: ', err)
      planDispatch({
        type: 'POSTS_COMPLETE',
        payload: { submissionStatus: 'FAILED' }
      })
    }
  }

  let detailViewButton = (
    <Button
      styleType="success"
      clickHandler={submitPlan}
      customClassName="mb10"
    >
      Save
    </Button>
  )

  let cancelPlanCreate = ()=>{
    trackEvent('edit_existing_production_plan_canceled', {
      companyId: company_id
    })
    dispatch({ type: 'GO_BACK' })
  }

  let cancelButton = (
    <Button clickHandler={cancelPlanCreate} customClassName="mb10 mr10" >Cancel</Button>
  )
  const rightSide = () => {
    switch (planState.rightSideState) {
      case 'FAILED':
        return generateErrors()
      case 'SUCCESS':
        return <p className="c-green m0">Production plan created!</p>
      default:
        return null
    }
  }

  const generateErrors = () => {
    const errorArray = []
    for (let widget in planState.errors) {
      if (planState.errors[widget].length) {
        planState.errors[widget].forEach((error, index) => {
          errorArray.push(
            <p className="c-red" key={`${error}-${index}`}>
              {error}
            </p>
          )
        })
      }
    }
    return <div className="posf">{errorArray}</div>
  }
  let leftComponents = (
    <>
      <ParentProductionPlanWidget editable={true} returnData={planDispatch} planState={planState}/>
      <CompanyDetailsWidget
        editable={true}
        companyName={planState.company_name}
        returnData={data =>
          planDispatch({ type: 'UPDATE_COMPANY_DETAILS', payload: data })
        }
      />
      <DeliveryLocationWidget
        editable={true}
        deliveryLocationData={initial_delivery_location_data}
        returnData={planDispatch}
      />
      <AvailableContractTypesWidget
        editable={true}
        contractTypes={contractTypes}
        returnData={planDispatch}
      />
      <UploadLegalFilesWidget
        editable={true}
        returnData={planDispatch}
        company_id={company_id}
        updateLegalFile={updateLegalFile} />
      <DeliveryWidget
        editable={true}
        contractType={planState?.selected_contract_type?.contract_type_enum}
        returnData={planDispatch}
        planState={planState}
        company_id={company_id}
        prodPlanData={prodPlanData}
      />
      <div className="df jcfe mt20 mb50 pl20">{cancelButton}{detailViewButton}</div>
    </>
  )

  useEffect(() => {
    if (planState.updateCompanyDetails) {
      set_company_id(planState.company_details.company_id)
      planDispatch({ type: 'FINISHED_UPDATING_COMPANY' })
    }
  }, [planState.updateCompanyDetails, planState.company_details])

  useEffect(() => {
    const init = async () => {
      getContractTypes().then(response => {
        if (!canceled.current) {
          setContractTypes(response)
        }
      })
      if (company_id) {
        getCompany(company_id).then(response => {
          if (response) {
            const payload = {
              external_reference_id: company_id,
              company_name: response.company_name,
              company_inventory_code: response.inventory_code
            }
            if (!canceled.current) {
              planDispatch({ type: 'HAS_COMPANY_ID', payload: payload })
              const delivery_location = {
                location_name: response.company_name,
                location_address1: response.address1,
                location_address2: response.address2,
                location_city: response.city,
                location_state: response.state,
                location_zipcode: response.zipcode,
                location_country: response.country
              }
              set_initial_delivery_location_data(delivery_location)
            }
          }
        })
      }
    }
    init()
  }, [setContractTypes, company_id, state.productionPlanDetails])

  const handleClose = result => {
    if (result === 'SUCCESS') {
      dispatch(planState.dispatchObj)
    } else {
      planDispatch({ type: 'SET_MODAL', payload: false })
    }
  }
  return (
    <ProductionPlanContext.Provider value={{ planState, planDispatch }}>
      <DetailView button={detailViewButton}>
        {leftComponents}
        <>
          <div className="m20">{rightSide()}</div>
        </>
      </DetailView>
      <ProductionPlanModal
        handleClose={handleClose}
        submissionStatus={planState.submissionStatus}
        showModal={planState.showModal}
      />
    </ProductionPlanContext.Provider>
  )
}

export default CreateProductionPlanView